import { render, staticRenderFns } from "./addPingan.vue?vue&type=template&id=316cfe56&scoped=true&"
import script from "./addPingan.vue?vue&type=script&lang=js&"
export * from "./addPingan.vue?vue&type=script&lang=js&"
import style0 from "./addPingan.vue?vue&type=style&index=0&id=316cfe56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316cfe56",
  null
  
)

export default component.exports